import React, { useMemo } from 'react';
import KeymastersPotView from 'src/ui/views/KeymastersPot/KeymastersPotView';
import { Layout } from 'src/ui/app';
import useWallet from 'src/hooks/useWallet';
import useNetwork from 'src/hooks/useNetwork';
import useProvider from 'src/hooks/useProvider';
import { SHOW_KEYMASTERS_POT } from 'src/config';
import useActiveAddress from 'src/hooks/useActiveAddress';
import { NULL_ADDRESS } from 'src/base/constants';
import FeatureFlagGuard from 'src/ui/util/FeatureFlagGuard';
import ErrorBoundary from 'src/ui/util/ErrorBoundary';

const KeymastersPot = () => {
	const [connect, address] = useWallet();
	const activeAddress = useActiveAddress( address );
	const vault = ( address !== activeAddress ) ? activeAddress : NULL_ADDRESS;
	const { network } = useNetwork();
	const provider = useProvider();
	const connected = useMemo( () => {
		return !!( address && provider );
	}, [address, provider]);

	function evaluateKeymastersPotCriteria() {
		// this will be used actually evaluate value
		return false; // for now
	}

	const criteriaNotMet = evaluateKeymastersPotCriteria();

	return (
		<Layout
			footerVariation="secondary"
			includeFooterInPage={true}
		>
			<FeatureFlagGuard featureFlag={SHOW_KEYMASTERS_POT}
				address={address}>
				<ErrorBoundary>
					<KeymastersPotView
						connect={connect}
						address={activeAddress}
						network={network}
						provider={provider}
						connected={connected}
						criteriaNotMet={criteriaNotMet}
						vault={vault}
					/>
				</ErrorBoundary>
			</FeatureFlagGuard>

		</Layout>
	);
};

export default KeymastersPot;

KeymastersPot.Layout = KeymastersPot;
